(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_collection-link"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", () => {
const observer = new IntersectionObserver(
(entries) => {
entries.forEach((entry, i) => {
if (entry.isIntersecting) {
setTimeout(() => {
entry.target.classList.add("is-visible");
}, i * 100); // nice stagger for mobile + desktop
}
});
},
{ threshold: 0.15 }
);

document.querySelectorAll(".collection-links__link").forEach((el) => {
observer.observe(el);
});
});
  } catch(e) { console.error(e); }
})();

})();
